import { ModuleMetadata } from '../base/initial-module';
import { initialSpecModule } from '../Spec/initial-module';

import { SpecHostOptions } from './options';

/**
 * @internal
 */
export function initialSpecWithHostModule<C, H>(options: Required<SpecHostOptions<C, H>>): ModuleMetadata {
  const moduleMetadata = initialSpecModule<C>(options);

  moduleMetadata.declarations.push(options.host);

  return moduleMetadata;
}
